"use client";

export { default } from "@/app/RootGlobalError";
